import { render, staticRenderFns } from "./InspectPoint.vue?vue&type=template&id=705c1bfc"
import script from "./InspectPoint.vue?vue&type=script&lang=js"
export * from "./InspectPoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports